
const glob = {

};
glob.Config = {
    UploadSize: 2,
    UploadType: ['image/jpg','image/png','image/jpeg']
}

export default glob